import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getModulesMaintenance, MODULES_MAINTENANCE_TAGS } from './endpoints';

const maintenanceApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getModulesMaintenance: getModulesMaintenance(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [MODULES_MAINTENANCE_TAGS],
  });

export const { useGetModulesMaintenanceQuery } = maintenanceApi;
